/**
 * Runs one feature's initialiser and keeps its failure to itself.
 *
 * The bundle is one script. Before this, every feature — from the MyHU header
 * to the Salesforce newsletter form — was initialised in sequence, at top level
 * or inside one jQuery `ready` handler, so a single throw anywhere took every
 * following feature down with it: an unguarded `localStorage` read (PR 1319,
 * Sentry HU-BOL-WEB-2B) and the header missing on /booking-online (Sentry
 * HUOPENAIR-2P) each silently disabled hundreds of lines of unrelated page
 * init for every visitor of the affected pages.
 *
 * Now a feature that throws is logged, reported to Sentry with a `feature`
 * tag, and skipped; the rest of the page still initialises.
 */
export function runFeature(name, init) {
    try {
        const result = init();

        // A feature that loads a chunk returns a promise; a rejection there has
        // no caller either, and would land in Sentry as an unhandled rejection.
        if (result && typeof result.catch === 'function') {
            result.catch((error) => reportFeatureFailure(name, error));
        }
    } catch (error) {
        reportFeatureFailure(name, error);
    }
}

function reportFeatureFailure(name, error) {
    console.error(`[hu] feature "${name}" failed to initialise and was skipped:`, error);

    // `window.Sentry` is the Loader Script's stub or the loaded SDK (see
    // layout.antlers.html); both accept captureException. Unset = no browser SDK.
    const sentry = window.Sentry;
    if (sentry && typeof sentry.captureException === 'function') {
        sentry.captureException(error, { tags: { feature: name } });
    }
}
